import { render, staticRenderFns } from "./dicesDetailTable.vue?vue&type=template&id=4cf23d9c"
import script from "./dicesDetailTable.vue?vue&type=script&lang=js"
export * from "./dicesDetailTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports